var map = {
	"./da/translation.json": 1099,
	"./de/translation.json": 1100,
	"./en/translation.json": 1101,
	"./es/translation.json": 1102,
	"./fr-CA/translation.json": 1103,
	"./fr/translation.json": 1104
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1098;